export const ACCOUNTS_API = "/atlas/api/v1/accounts";
export const CLOSE_CALL_API = (eventId: string) =>
  `/margin-provider/api/v1/calls-alerts/${eventId}/close`;
export const BALANCE_API = "/margin-provider/api/v1/balances";
export const CASH_BALANCE_API = "/cash-balances/api/v2/available";
export const CORRESPONDENT_API =
  "/correspondent-provider/api/v1/correspondent/summary";
export const GET_MARGIN_CALLS = "/margin-provider/api/v1/calls-alerts";
export const GET_MARGINS = "/margin-provider/api/v1/margins";
export const POST_ADD_NOTE = (eventId: string) =>
  `/margin-provider/api/v1/calls-alerts/${eventId}/note`;
export const MODIFY_CALL_API = (eventId: string) =>
  `/margin-provider/api/v1/calls/${eventId}/modify`;
export const CREATE_CALL_API = "/margin-provider/api/v1/calls";
export const GET_CORRESPONDENTS_API =
  "/correspondent-provider/api/v2/correspondents";
export const GET_REQUIREMENTS_API = (accountId: string) =>
  `${GET_MARGIN_CALLS}/${accountId}/requirements`;
export const GET_EVENT_NAMES_API =
  "/margin-provider/api/v1/calls-alerts/event-names";
export const GET_LAST_PROCESS_DATE_API =
  "​/margin-provider/api/v1/last-process-date";
export const GET_MASTER_SUB_ACCOUNT_ROLLUP_API =
  "/margin-provider/api/v1/balances";
export const GET_CALL_ALERTS_API = "/margin-provider/api/v1/calls-alerts";
export const GET_ATLAS_ACCOUNTS = "/atlas/api/v1/accounts";
